import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Typography,
} from "@mui/material";
import {
    AccountBalanceWalletRounded,
    LockRounded,
    ReceiptLongRounded,
} from "@mui/icons-material";
import { toPriceWithComma } from "../../helper/utils";
import { gatewayApplication_query } from "../../network/api/gatewayApplication.api";
import { suggest_query } from "../../network/api/suggest.api";
import { ErrorContext } from "../../components/GympinPagesProvider";
import { useSelector } from "react-redux";
import { getTax } from "../../helper/serverSettingsHelper";
import {
    increaseCorporateDeposit_requestIncreaseCorporateDeposits,
    increaseCorporateDeposit_requestIncreaseCorporateDepositsDraft,
} from "../../network/api/increaseCorporateDeposit.api";
import _OfflinePaymentModal from "./partials/_OfflinePaymentModal";
import _GatewaySelectorGrid from "./partials/_GatewaySelectorGrid";
import _ChargeAmountPresets from "./partials/_ChargeAmountPresets";
import _ChargeSummaryBreakdown from "./partials/_ChargeSummaryBreakdown";

const _ChargeCreateInvoice = ({ refreshList }) => {
    const error = useContext(ErrorContext);
    const corporate = useSelector(({ corporate }) => corporate.corporate);
    const [paymentGatewaysApplication, setPaymentGatewaysApplication] = useState({});
    const [suggests, setSuggests] = useState(null);
    const [amountToPay, SetAmountToPay] = useState("");
    const [transactionReference, SetTransactionRefrence] = useState("");
    const [transactionDescription, SetTransactionDescription] = useState("");
    const [chequeDate, setChequeDate] = useState(null);
    const [requestInvoice, setRequestInvoice] = useState(false);
    const [selectedGateway, setSelectedGatewayApplication] = useState(null);
    const [requestProFormaInvoice, setRequestProFormaInvoice] = useState(false);
    const [openModalFastPay, setOpenModalFastPay] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const serverSettings = useSelector(settings => settings);
    const taxPrice = getTax(serverSettings) || 0;

    useEffect(() => {
        getPaymentGateways();
        getPaymentSuggest();
    }, []);

    function getPaymentGateways() {
        gatewayApplication_query({
            queryType: "FILTER",
            Application: "WEBCORPORATE",
            paging: { Page: 0, Size: 300, orderBy: "Id", Desc: false }
        }).then(result => {
            const data = result.data.Data;
            setPaymentGatewaysApplication(data || {});
            try {
                const defaultGw = data?.content?.find(g => g.IsDefault === true) || data?.content?.[0];
                if (defaultGw) setSelectedGatewayApplication(defaultGw);
            } catch (e) {}
        }).catch(e => {
            try {
                error.showError({ message: e.response?.data?.Message || "خطا در دریافت درگاه‌های پرداخت" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    function getPaymentSuggest() {
        suggest_query({
            queryType: "FILTER",
            Application: "WEBCORPORATE",
            paging: { Page: 0, Size: 300, orderBy: "amount", Desc: false }
        }).then(result => {
            setSuggests(result.data.Data?.content || []);
        }).catch(e => {
            try {
                error.showError({ message: e.response?.data?.Message || "خطا در دریافت مبالغ پیشنهادی" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    function changeGateway(item) {
        if (corporate?.Status === "DEMO" || corporate?.Status === "SECURE_DEMO") {
            error.showError({ message: "عملیات مالی در حالت نسخه نمایشی (Demo) غیرفعال است" });
            return;
        }
        if (item?.Gateway?.GatewayType === "BANK_PORTAL") {
            setRequestProFormaInvoice(false);
        }
        setSelectedGatewayApplication(item);
    }

    const rawAmount = parseInt(amountToPay || "0", 10) || 0;
    const taxAmount = Math.round(rawAmount * (parseFloat(taxPrice) / 100));
    const totalAmount = rawAmount + taxAmount;

    function getlabelOfRefrence() {
        if (!selectedGateway) return "شناسه رهگیری";
        switch (selectedGateway?.Gateway?.GatewayType) {
            case 'CARD_TRANSFER':
                return "کد پیگیری / ارجاع کارت به کارت";
            case 'BANK_TRANSFER':
                return "شماره پیگیری واریز به حساب / ساتنا / پایا";
            case 'CHEQUE':
                return "شماره صیادی / سریال چک";
            default:
                return "کد رهگیری تراکنش";
        }
    }

    function submitPaymentDraft(e) {
        if (e) e.preventDefault();
        if (rawAmount < 500000) {
            error.showError({ message: "حداقل مبلغ شارژ حساب ۵۰۰،۰۰۰ تومان می‌باشد" });
            return;
        }
        if (!selectedGateway) {
            error.showError({ message: "لطفاً یک درگاه یا روش پرداخت انتخاب کنید" });
            return;
        }
        if (corporate?.Status === "DEMO" || corporate?.Status === "SECURE_DEMO") {
            error.showError({ message: "در نسخه نمایشی (Demo) امکان شارژ وجود ندارد" });
            return;
        }

        setSubmitting(true);
        increaseCorporateDeposit_requestIncreaseCorporateDepositsDraft({
            GatewayApplication: { Id: selectedGateway?.Id },
            TransactionReference: transactionReference || undefined,
            Application: "WEBCORPORATE",
            ChequeDate: chequeDate || undefined,
            Draft: true,
            RequestInvoice: requestInvoice,
            TransactionType: "CHARGE_CORPORATE",
            Description: transactionDescription || undefined,
            Amount: totalAmount,
            CorporateId: corporate?.Id
        }).then(() => {
            setSubmitting(false);
            error.showError({ message: "پیش‌فاکتور با موفقیت صادر شد" });
            SetAmountToPay("");
            if (refreshList) refreshList();
        }).catch(err => {
            setSubmitting(false);
            try {
                error.showError({ message: err.response?.data?.Message || "خطا در ثبت پیش‌فاکتور" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    function handleStartPayment(e) {
        if (e) e.preventDefault();
        if (rawAmount < 500000) {
            error.showError({ message: "حداقل مبلغ شارژ حساب ۵۰۰،۰۰۰ تومان می‌باشد" });
            return;
        }
        if (!selectedGateway) {
            error.showError({ message: "لطفاً درگاه پرداخت را انتخاب کنید" });
            return;
        }
        if (corporate?.Status === "DEMO" || corporate?.Status === "SECURE_DEMO") {
            error.showError({ message: "در نسخه نمایشی (Demo) امکان شارژ وجود ندارد" });
            return;
        }

        if (selectedGateway?.Gateway?.GatewayType === "BANK_PORTAL") {
            setSubmitting(true);
            increaseCorporateDeposit_requestIncreaseCorporateDeposits({
                GatewayApplication: { Id: selectedGateway?.Id },
                Application: "WEBCORPORATE",
                Draft: false,
                RequestInvoice: requestInvoice,
                TransactionType: "CHARGE_CORPORATE",
                Amount: totalAmount,
                CorporateId: corporate?.Id
            }).then(result => {
                setSubmitting(false);
                if (result.data?.Data?.startsWith("http")) {
                    window.location.href = result.data.Data;
                } else {
                    error.showError({ message: "درخواست پرداخت ثبت شد. شناسه: " + result.data.Data });
                    if (refreshList) refreshList();
                }
            }).catch(err => {
                setSubmitting(false);
                try {
                    error.showError({ message: err.response?.data?.Message || "خطا در اتصال به درگاه" });
                } catch (f) {
                    error.showError({ message: "خطای نامشخص" });
                }
            });
        } else {
            setOpenModalFastPay(true);
        }
    }

    function handleConfirmOfflinePay(e) {
        e.preventDefault();
        if (!transactionReference) {
            error.showError({ message: `${getlabelOfRefrence()} الزامی است` });
            return;
        }

        setSubmitting(true);
        increaseCorporateDeposit_requestIncreaseCorporateDeposits({
            GatewayApplication: { Id: selectedGateway?.Id },
            TransactionReference: transactionReference,
            Application: "WEBCORPORATE",
            ChequeDate: chequeDate || undefined,
            Draft: true,
            RequestInvoice: requestInvoice,
            TransactionType: "CHARGE_CORPORATE",
            Description: transactionDescription || undefined,
            Amount: totalAmount,
            CorporateId: corporate?.Id
        }).then(() => {
            setSubmitting(false);
            setOpenModalFastPay(false);
            SetTransactionRefrence("");
            SetAmountToPay("");
            error.showError({ message: "درخواست پرداخت با موفقیت ثبت شد و پس از بررسی حسابداری تایید خواهد شد" });
            if (refreshList) refreshList();
        }).catch(err => {
            setSubmitting(false);
            try {
                error.showError({ message: err.response?.data?.Message || "خطا در ثبت پرداخت" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    const gateways = paymentGatewaysApplication?.content || [];

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                overflow: 'hidden'
            }}
        >
            {/* Card Header */}
            <Box
                sx={{
                    p: 2.5,
                    px: 3,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        borderRadius: 3,
                        bgcolor: 'rgba(28, 139, 156, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main'
                    }}
                >
                    <AccountBalanceWalletRounded />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
                        افزایش اعتبار حساب سازمانی
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        انتخاب مبلغ دلخواه یا بسته‌های پیشنهادی
                    </Typography>
                </Box>
            </Box>

            <CardContent sx={{ p: { xs: 2.5, sm: 3 }, display: 'flex', flexDirection: 'column', gap: 3 }}>
                <_ChargeAmountPresets
                    suggests={suggests}
                    rawAmount={rawAmount}
                    amountToPay={amountToPay}
                    SetAmountToPay={SetAmountToPay}
                />

                <_GatewaySelectorGrid
                    gateways={gateways}
                    selectedGateway={selectedGateway}
                    changeGateway={changeGateway}
                />

                <_ChargeSummaryBreakdown
                    selectedGateway={selectedGateway}
                    requestProFormaInvoice={requestProFormaInvoice}
                    setRequestProFormaInvoice={setRequestProFormaInvoice}
                    rawAmount={rawAmount}
                    taxAmount={taxAmount}
                    taxPrice={taxPrice}
                    totalAmount={totalAmount}
                />

                {/* Action Button */}
                <Box>
                    {requestProFormaInvoice ? (
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={submitting || rawAmount < 500000}
                            onClick={submitPaymentDraft}
                            startIcon={submitting ? null : <ReceiptLongRounded sx={{ ml: 1, mr: -0.5 }} />}
                            sx={{
                                py: 1.4,
                                borderRadius: 3,
                                fontWeight: 800,
                                fontSize: '1rem',
                                boxShadow: '0 4px 16px rgba(28, 139, 156, 0.25)'
                            }}
                        >
                            {submitting ? <CircularProgress size={24} color="inherit" /> : "صدور و ثبت پیش‌فاکتور"}
                        </Button>
                    ) : (
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={submitting || rawAmount < 500000}
                            onClick={handleStartPayment}
                            startIcon={submitting ? null : <LockRounded sx={{ ml: 1, mr: -0.5 }} />}
                            sx={{
                                py: 1.4,
                                borderRadius: 3,
                                fontWeight: 800,
                                fontSize: '1rem',
                                background: 'linear-gradient(135deg, #1c8b9c 0%, #157382 100%)',
                                boxShadow: '0 4px 16px rgba(28, 139, 156, 0.25)'
                            }}
                        >
                            {submitting ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : selectedGateway?.Gateway?.GatewayType === "BANK_PORTAL" ? (
                                `پرداخت آنلاین (${toPriceWithComma(totalAmount)} تومان)`
                            ) : (
                                "ثبت و پرداخت نهایی"
                            )}
                        </Button>
                    )}
                </Box>
            </CardContent>

            <_OfflinePaymentModal
                open={openModalFastPay}
                onClose={() => setOpenModalFastPay(false)}
                submitting={submitting}
                handleConfirmOfflinePay={handleConfirmOfflinePay}
                rawAmount={rawAmount}
                taxAmount={taxAmount}
                taxPrice={taxPrice}
                totalAmount={totalAmount}
                selectedGateway={selectedGateway}
                getlabelOfRefrence={getlabelOfRefrence}
                transactionReference={transactionReference}
                SetTransactionRefrence={SetTransactionRefrence}
                transactionDescription={transactionDescription}
                SetTransactionDescription={SetTransactionDescription}
            />
        </Card>
    );
};

export default _ChargeCreateInvoice;
